import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getRecentGamesStart } from 'store/redux-slices/casinoMenu'

const useRecentGames = ({ category = false }) => {
  const { recentGames, recentGamesLoading } = useSelector((state) => state.casinoMenu)
  const { userDetails } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { selectedLanguageCode, languageData } = useSelector((state) => state.language)

  useEffect(() => {
    if (category && userDetails) {
      dispatch(getRecentGamesStart({ limit: 10 }))
    }
  }, [category, dispatch, userDetails])

  return {
    recentGames,
    userDetails,
    navigate,
    selectedLanguageCode,
    languageData,
    recentGamesLoading
  }
}

export default useRecentGames
